// Phase 4 OM — Aybars NJ QR scan token validator (V1 simulation).
//
// Format: WO-<woId-suffix>-<short-hash> (case-insensitive).
//   Example: WO-12848A-A1F4
//
// V1 simulation only — V1.5+ backend resume swaps in a signed token with
// expiry + replay protection + audit emission. Phase 4 admin Settings page
// (Wave-16 backlog) will expose a per-WO regenerate button when the token
// gets lost / leaked.

const SCAN_TOKEN_RE = /^WO-[0-9A-Z]{4,}-[A-F0-9]{4,}$/i

export function isValidScanToken(token: string | undefined | null): boolean {
  if (!token) return false
  return SCAN_TOKEN_RE.test(token.trim())
}
